import React, { useState, useEffect, useRef } from "react";
import { Field, useFormik } from "formik";
import * as Yup from "yup";
import { InputGroup, FormControl, ButtonGroup, Button, ButtonToolbar } from 'react-bootstrap';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../../../app/actions/generalActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_themeBase/_partials/controls";
import { useSubheader } from "../../../../../../_themeBase/layout";
import { ModalProgressBar } from "../../../../../../_themeBase/_partials/controls";
import { toAbsoluteUrl } from "../../../../../../_themeBase/_helpers";
import { FormattedMessage, useIntl } from "react-intl";

const ObjectPayment = ({
  basePath,
  isFullAccess,
  api,
  methodName,
  reducerName,
  reduxState,
  history,
  match: {
    params: { id },
  },
  subSystem,
  transactionType,
  showTitle
}) => {
  // Subheader
  const suhbeader = useSubheader();

  const intl = useIntl();
  const [title, setTitle] = useState();
  const [title1, setTitle1] = useState();
  const [title2, setTitle2] = useState();
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);

  const initPayment = {
    id: undefined,
    userId: null,
    userFullName: "",
    amount: transactionType === 3 ? 1000 : 0,
    transactionTypeId: 0,
    subSystemType: "",
    clientUrl: "",
    bankAccountId: 0,
    bankAccountTitle: "",
    bankLogoUrl: "/Images/Logo/Bank.jpg",
    orderId: "",
    reservationId: null,
    refrenceNumber: "",
    traceNumber: "",
    statusCode: "",
    timeStamp: "",
    reverifyTimeStamp: "",
    verifyingCode: "",
    result: false,
  };
  const [paymentObject, setPaymentObject] = useState(initPayment);
  const { currentState } = useSelector(
    (state) => ({ currentState: state[reducerName][reduxState] }),
    shallowEqual
  );
  const user = useSelector((state) => state.auth.user, shallowEqual);

  useEffect(() => {
    if (id)
      dispatch(actions.fetchObject(api, name, id, methodName));
  }, [id, dispatch]);

  useEffect(() => {
    if (!id && user.id && transactionType === 3) {
      const query = {
        whereClause: "",
        whereClauseParameters: [
        ],
        orderClause: "id asc ",
        skipCount: 0,
        takeCount: 100,
        filter: {}
      };

      //query.filter = { dormId: 0 }
      dispatch(actions.fetchObjects("api/bankAccount", "accounts", query, "GetAllDormBankAccountsByUser"));

      setPaymentObject(
        {
          ...paymentObject,
          bankLogoUrl: paymentObject.bankLogoUrl,
          // reservationId: objectForEdit.id,
          userFullName: user.firstName + " " + user.lastName,
          userCredit: user.credit,
          //amount: objectForEdit.price,
          transactionTypeId: transactionType,
          clientUrl: `${window.location}`,
          subSystemType: subSystem
        })
    }

  }, [user]);


  const { actionsLoading, objectForEdit, name } = useSelector(
    (state) => ({
      actionsLoading: currentState.actionsLoading,
      objectForEdit: currentState.objectForEdit,
      name: currentState.name,
    }),
    shallowEqual
  );

  useEffect(() => {
    let _title = id ? "" : intl.formatMessage({ id: showTitle });
    const query = {
      whereClause: "",
      whereClauseParameters: [
      ],
      orderClause: "id asc ",
      skipCount: 0,
      takeCount: 100,
      filter: {}
    };

    if (objectForEdit && id) {
      _title = intl.formatMessage({ id: showTitle });

      // if (currentState.name === "dormMyReservations" || currentState.name === "dormManageReservations") {
      if (subSystem === "Dorm") {
        if (transactionType === 40) // رزرو اتاق
        {
          query.filter = { dormId: objectForEdit.dormId }
          dispatch(actions.fetchObjects("api/bankAccount", "accounts", query, "GetDormBankAccounts"));

          _title = _title + " رزرو اتاق : "
          setTitle1("ترم تحصیلی : " + objectForEdit.termTitle)
          setTitle2("مشخصات اتاق : " + objectForEdit.roomTitle + " - " + objectForEdit.blockTitle + " - " + objectForEdit.dormTitle)
          setPaymentObject(
            {
              ...paymentObject,
              bankLogoUrl: paymentObject.bankLogoUrl,
              reservationId: objectForEdit.id,
              userFullName: objectForEdit.userFullName,
              userCredit: objectForEdit.userCredit,
              amount: objectForEdit.price,
              transactionTypeId: transactionType,
              clientUrl: `${window.location}`,
              subSystemType: subSystem
            })
        }

      }
    }


    setTitle(_title);
  }, [objectForEdit, id]);

  const { bankAccounts } = useSelector(
    (state) => ({ bankAccounts: state.baseInfo.accounts.entities }),
    shallowEqual
  );


  const backToObjectsList = () => {
    dispatch(actions.fetchObject(api, name, undefined, methodName))
    history.push(basePath);
  };

  const btnRef = useRef();
  const payObjectClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };


  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }
    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }
    return "";
  };
  const ObjectEditSchema = Yup.object().shape({
    bankAccountId: Yup.number()
      .positive("لطفا یک درگاه را انتخاب نمایید")
    ,
  });

  const formik = useFormik({
    initialValues: paymentObject,
    validationSchema: ObjectEditSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      if (paymentObject.amount > 0) {
        dispatch(actions.pay("api/EPayPayment", name, { ...paymentObject, bankAccountId: values.bankAccountId }, "Pay")).then((response) => {
          //if (response && (response.message || response.data.message))
          backToObjectsList()
        });
      }
      else if (paymentObject.amount === 0) {
        dispatch(actions.payFree("api/EPayPayment", name, { ...paymentObject, bankAccountId: values.bankAccountId }, "PayFree")).then(() =>
          backToObjectsList()
        );
      }
    },
  });


  return (
    // <FilterObjectsUIProvider>
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader >
        <div>
          <div className="text-success text-bold mt-4 mb-2">{title}</div>
          <div className="text-gray text-bold mt-4 mb-2">در صورتی که اطلاعات مورد تایید شماست لطفا درگاه مورد نظر خود را انتخاب نموده و گزینه پرداخت را کلیک نمایید.</div>
        </div>
        <CardHeaderToolbar>
          <button
            type="button"
            onClick={backToObjectsList}
            className="btn btn-light"
          >
            <i className="fa fa-arrow-left"></i>
            {intl.formatMessage({ id: "MODULES.GENERAL.BUTTONBACK" })}
          </button>
          {`  `}
          <button
            type="submit"
            onClick={payObjectClick}
            disabled={!isFullAccess}
            className={`btn btn-success font-weight-bold ml-2 `}
          >
            <span>
              {" "}
              <FormattedMessage id="BUTTON.PAYMENT" />{" "}
            </span>
            {actionsLoading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>

        <div className="mt-5">
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework"
          >

            {subSystem === "Dorm" && transactionType === 40 &&
              <>
                <div className="text-info text-bold mb-4 ml-20">{intl.formatMessage({ id: "AUTH.INPUT.FULLNAME" })} : {paymentObject.userFullName}</div>
                <div className="text-info text-bold mb-4 ml-20">{intl.formatMessage({ id: "PAYMENT.PRICE.ROOM" })} : {paymentObject.amount} {" ریال "}</div>
                <div className="text-success text-bold mb-4 ml-20">{intl.formatMessage({ id: "PAYMENT.PRICE" })} : {paymentObject.userCredit ? paymentObject.amount - paymentObject.userCredit : paymentObject.amount} {" ریال "}</div>
                <div className="text-info text-bold mb-4 ml-20">{title1}</div>
                <div className="text-info text-bold mb-4 ml-20">{title2}</div>
              </>
            }


            {/* {subSystem === "Dorm" && transactionType === 3 && */}
            {transactionType === 3 && // افزایش اعتبار خوابگاهی و ورزشی
              <>
                <div className="form-group row">
                  <label className="col-xl-3 col-lg-3 col-form-label text-alert">
                    مبلغ تراکنش (ریال)
                  </label>
                  <div className="col-lg-9 col-xl-6">
                    <input
                      defaultValue="1000"
                      type="number"
                      min="1000"
                      placeholder="مبلغ تراکنش (بیشتر از 1000 ریال باشد)"
                      className={`form-control form-control-lg  ${getInputClasses(
                        "amount"
                      )}`}
                      name="amount"
                      {...formik.getFieldProps("amount")}
                      onChange={(e) => {
                        formik.setFieldValue("amount", e.target.value)

                        setPaymentObject(
                          {
                            ...paymentObject,
                            amount: +e.target.value,
                          })
                      }}
                    />
                    {formik.touched.amount && formik.errors.amount ? (
                      <div className="invalid-feedback">{formik.errors.amount}</div>
                    ) : null}
                  </div>
                </div>
              </>
            }

            <div className="form-group fv-plugins-icon-container flex-wrap mt-10 ml-20">
              {/* <label>انتخاب درگاه بانک </label> */}
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">درگاه های بانکی :</div>
                <div className="fv-help-block text-warning mt-3">(اگر درگاهی برای شما نمایش داده نشده است شما به لیست درگاه ها دسترسی ندارید و نیاز است با پشتیبانی تماس بگیرید. )</div>
              </div>
              {paymentObject && paymentObject.amount > 0 && bankAccounts && bankAccounts.map((bankAccount) => (
                <Button
                  size="sm"
                  style={{ minWidth: "140px" }}
                  key={bankAccount.id}
                  value={bankAccount.id}
                  variant="outline-primary"
                  className="m-4 p-5"
                  onClick={(e) => {
                    formik.setFieldValue("bankAccountId", bankAccount.id)
                  }}
                >
                  <img
                    src={toAbsoluteUrl(bankAccount.bankLogoUrl)}
                    alt="-"
                    style={{ width: "3.5rem" }}
                  />
                  <div className=" font-weight-bold mt-5">
                    {bankAccount.title}
                  </div>
                </Button>
              ))}
              {paymentObject && paymentObject.amount === 0 && bankAccounts && bankAccounts.map((bankAccount) => (
                <Button
                  size="sm"
                  style={{ minWidth: "140px" }}
                  key={bankAccount.id}
                  value={bankAccount.id}
                  variant="outline-primary"
                  className="m-4 p-5"
                  onClick={(e) => {
                    formik.setFieldValue("bankAccountId", bankAccount.id)
                  }}
                >
                  <img
                    src={toAbsoluteUrl(bankAccount.bankLogoUrl)}
                    alt="-"
                    style={{ width: "3.5rem" }}
                  />
                  <div className=" font-weight-bold mt-5">
                    {bankAccount.title}
                  </div>
                </Button>
              ))}
              {/* {formik.touched.bankAccountId && formik.errors.bankAccountId ? ( */}
              <div className="fv-plugins-message-container mt-8 ml-8">
                <div className="fv-help-block text-danger">{formik.errors.bankAccountId}</div>
              </div>
              {/* ) : null} */}
            </div>
            <button
              type="submit"
              style={{ display: "none" }}
              ref={btnRef}
            // onSubmit={() => handleSubmit()}
            ></button>
          </form>

        </div>
      </CardBody>
    </Card>
    // </FilterObjectsUIProvider>
  );
}

export default ObjectPayment

